import { useState, useEffect } from 'react';
import axios from 'axios';
import { Admin_Employee, Admin_Employee_Filter } from '../../../../constants';

export const useEmployees = (filters) => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [availableRoles, setAvailableRoles] = useState([]);

  const limit = 10;

  // Fetch filter options from dedicated endpoint
  const fetchFilterOptions = async () => {
    try {
      const res = await axios.get(`${Admin_Employee_Filter}`);
      if (res.data.success) {
        setAvailableRoles(res.data.data.roles || []);
      }
    } catch (err) {
      console.error('Error fetching filter options:', err);
      setAvailableRoles([]);
    }
  };

  // Fetch employees with filters
  const fetchEmployees = async () => {
    try {
      setLoading(true);
      setError(null);

      const params = new URLSearchParams({
        page: filters.page.toString(),
        limit: limit.toString(),
        search: filters.search,
      });

      if (filters.filterActive !== 'All') {
        params.append(
          'is_active',
          filters.filterActive === 'Active' ? 'true' : 'false'
        );
      }

      if (filters.filterRole !== 'All') {
        params.append('role', filters.filterRole);
      }

      const res = await axios.get(`${Admin_Employee}?${params}`);

      if (res.data.success) {
        setEmployees(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
        setTotalEmployees(res.data.pagination.total);
      } else {
        setError('Failed to fetch employees');
      }
    } catch (err) {
      console.error('Error fetching employees:', err);
      setError('Failed to fetch employees. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, [filters.search, filters.filterActive, filters.filterRole, filters.page]);

  return {
    employees,
    loading,
    error,
    totalPages,
    totalEmployees,
    availableRoles,
    limit,
    refetch: fetchEmployees,
  };
};
